const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export function centsToDollars(amount?: number | null): number | undefined {
  if (typeof amount !== "number") return undefined;
  return amount / 100;
}

export function formatMoney(amount?: number): string {
  if (typeof amount !== "number") return "";
  return currencyFormatter.format(amount);
}
